import Phaser from "phaser";

export default class Breakout extends Phaser.Scene {
    bricks;
    paddle;
    ball;
    brickCount = 0;
    lives = 1;
    completed = false;
    enterText = null;
    appContext = null;

    constructor(sceneKey, appContext) {
        super({
            key: sceneKey
        });

        this.appContext = appContext
    }

    preload = () => {
        this.load.atlas('assets', '/assets/breakout/breakout.png', '/assets/breakout/breakout.json');
    }

    create = () => {
        this.lives = 1;
        if(this.completed){
            this.showNext()
        } else {
            //  Enable world bounds, but disable the floor
            this.physics.world.setBoundsCollision(true, true, true, false);

            //  Create the bricks in a 10x6 grid
            this.bricks = this.physics.add.staticGroup({
                key: 'assets', frame: ['blue1', 'red1', 'green1', 'yellow1', 'silver1', 'purple1'],
                frameQuantity: 10,
                gridAlign: {width: 10, height: 6, cellWidth: 64, cellHeight: 32, x: 112, y: 100}
            });

            this.ball = this.physics.add.image(400, 500, 'assets', 'ball1').setCollideWorldBounds(true).setBounce(1);
            this.ball.setData('onPaddle', true);

            const rightWall = this.physics.add.staticSprite(801, 400);
            this.physics.world.enable(rightWall);
            rightWall.setSize(2, 1200);

            this.paddle = this.physics.add.image(400, 550, 'assets', 'paddle1').setImmovable();

            //  Our colliders
            this.physics.add.collider(this.ball, this.bricks, this.hitBrick, null, this);
            this.physics.add.collider(this.ball, this.paddle, this.hitPaddle, null, this);
            this.physics.add.collider(this.ball, rightWall)

            //  Input events
            this.input.on('pointermove', function (pointer) {
                if(!this.enterText.visible) {
                    //  Keep the paddle within the game
                    this.paddle.x = Phaser.Math.Clamp(pointer.x, 52, 748);

                    if (this.ball.getData('onPaddle')) {
                        this.ball.x = this.paddle.x;
                    }
                }
            }, this);

            this.input.on('pointerup', function (pointer) {
                if(this.enterText.visible){
                    this.enterText.visible = false
                } else {
                    if (this.ball.getData('onPaddle')) {
                        this.ball.setVelocity(-75, -300);
                        this.ball.setData('onPaddle', false);
                    }
                }
            }, this);

            this.showMessage("Remove all the blocks to enter this room\n" +
                "(click to start)")
        }
    }

    showMessage = (message) => {
        let textObject = this.add.text(400, 400, message,
            {
                padding: 6,
                fontSize: '24px',
                fontFamily: 'courier, courier new, serif'
            });

        textObject.x = textObject.x - (textObject.width / 2)
        textObject.setShadow(3, 3, 'rgba(0,0,0,0.5)', 5);
        // textObject.style.padding = 8
        // textObject.style.fontSize = '46px'

        textObject.setBackgroundColor("#aa6600")
        textObject.visible = true
        textObject.setDepth(100)
        // setTimeout(() => textObject.visible = false, 3000)
        this.enterText = textObject
    }

    hitBrick = (ball, brick) => {
        brick.disableBody(true, true);

        this.brickCount++

        console.log("brickCount", this.brickCount)

        if (this.bricks.countActive() === 0) {
            this.showNext()
        }
    }

    showNext = () => {
        this.completed = true
        this.scene.start("vipRoom")
        this.appContext.gameContext.setCurrentRoom("vipRoom")
    }

    resetBall = () => {
        this.ball.setVelocity(0);
        this.ball.setPosition(this.paddle.x, 500);
        this.ball.setData('onPaddle', true);
    }

    die = () => {
        if(this.lives > 0)
        {
            this.showMessage("One more try ...")
            this.lives = 0
            this.resetBall();
        } else{
            this.scene.start("firstWorld")
            this.appContext.gameContext.setCurrentRoom("firstWorld")
        }


    }

    resetLevel = () => {
        this.resetBall();

        this.bricks.children.each(function (brick) {

            brick.enableBody(false, 0, 0, true, true);

        });
    }

    hitPaddle = (ball, paddle) => {
        var diff = 0;

        if (ball.x < paddle.x) {
            //  Ball is on the left-hand side of the paddle
            diff = paddle.x - ball.x;
            ball.setVelocityX(-10 * diff);
        } else if (ball.x > paddle.x) {
            //  Ball is on the right-hand side of the paddle
            diff = ball.x - paddle.x;
            ball.setVelocityX(10 * diff);
        } else {
            //  Ball is perfectly in the middle
            //  Add a little random X to stop it bouncing straight up!
            ball.setVelocityX(2 + Math.random() * 8);
        }
    }

    update = () => {
        if (this.ball.y > 600) {
            this.die()
        }
    }
}
